import { Select, Table } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { submitMockTest } from '../../../../actions/mock-test';
import KatexViewer from '@/helpers/Katex';

//statement question template
const TempalteStatement = ({ question, section, model }) => {
  const dispatch = useDispatch();
  const chooseArr = [
    {
      key: '0',
      value: 'True',
    },
    {
      key: '1',
      value: 'False',
    },
  ];
  const handleStatementChoose = (value, ansId) => {
    console.log(Boolean(value), value);

    const statementData = {
      model: model,
      section: section,
      question: question?.id,
      answer: ansId,
      is_correct: value === 'True' ? true : false,
    };
    dispatch(submitMockTest(statementData));
  };

  const columns = [
    {
      dataIndex: 'sn',
      width: 100,
    },
    {
      dataIndex: 'text',
    },
    {
      dataIndex: 'select',
      width: 300,
    },
  ];
  const statementData = question?.answer?.map(({ id, text }, index) => ({
    sn: index + 1,
    //   sn: `${(question?.meta?.page - 1) * question?.meta?.per_page + index + 1}`,
    text: question?.has_expression ? <KatexViewer text={text} /> : text,
    select: (
      <Select
        onChange={(value) => handleStatementChoose(value, id)}
        style={{
          width: 200,
          fontSize: '10px',
        }}
        placeholder="Select"
      >
        {chooseArr.map((obj) => (
          <Select.Option key={obj.key} value={obj.value}>
            {obj.value}
          </Select.Option>
        ))}
      </Select>
    ),
  }));

  return (
    <div className="mock-test-question-wrapper">
      <div className="type_blank">
        <div className="sl-item mt-3">
          <div className="question-title-group">
            <div className="number" id={`q-${question.q_no}`}>
              {question.q_no}
            </div>
          </div>
        </div>
        <div className="question-title">
          {question?.instruction ? (
            <div className="d-flex instruction-question">
              <div
                dangerouslySetInnerHTML={{ __html: question?.instruction }}
                className="px-2"
              />
            </div>
          ) : (
            ''
          )}
          <p>
            {question?.has_expression ? (
              <KatexViewer text={question?.title} />
            ) : (
              question.title
            )}
          </p>
        </div>

        <div className="container">
          <Table
            bordered
            showHeader={false}
            columns={columns}
            dataSource={statementData}
            pagination={false}
          />
        </div>
      </div>
    </div>
  );
};

export default TempalteStatement;
